import React, { Suspense } from 'react';
import './App.css';
import Header from './components/header/header';
import Navbar from './components/navbar/navbar';
import Footer from './components/Footer/footer';
import { BrowserRouter as Router, Routes, Route } from "react-router-dom";
const Home = React.lazy(() => import('./components/home/home'));
const Services = React.lazy(() => import('./components/Services/services'));
const Products = React.lazy(() => import('./components/Products/products'));
const Testimonials = React.lazy(() => import('./components/Testimonials/testimonials'));
const ContactUs = React.lazy(() => import('./components/ContactUs/contactus'));
const AboutUs = React.lazy(() => import('./components/AboutUs/aboutus'));
const ProductDetails = React.lazy(() => import('./components/Products/ProductDetails'));
const ServiceDetails = React.lazy(() => import('./components/Services/ServiceDetails'));


function App() {
  return (
    <Router>
      <>
        <Header />
        <Navbar />
        <Routes>
          <Route
            path="/"
            element={
              <>
                <div id="home-section">
                  <Home />
                </div>
                <div id="services-section">
                  <Services />
                </div>
                <div id="products-section">
                  <Products />
                </div>
                <div id="testimonials-section">
                  <Testimonials />
                </div>
                <div id="contactus-section">
                  <ContactUs />
                </div>
                <div id="aboutus-section">
                  <AboutUs />
                </div>
              </>
            }
          />
          <Route path='/about' element={<AboutUs/>} />
          <Route path='/contact' element={<ContactUs/>} />
          <Route path="/product/:id" element={<ProductDetails />} />

          <Route path="/service/:id" element={<ServiceDetails />} />
        </Routes>
        <Footer />
      </>
    </Router>
  );
}

export default App;
